export default __webpack_public_path__ + "static/media/radio-remove.73a6d866.svg";